import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Input, EAA_ErrorText, EAA_Memo, EAA_Add_Btn } from '~/components/EditAndAddItem';
import { getInitialShipData } from './initial_ship_data';
import ShipSchedule from '../ShipSchedule';

const styles = (theme) => ({
    container: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    cardContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
    },
    card: {
        // display: 'flex',
        // flexDirection: 'row',
        // alignItems: 'left',
        // justifyContent: 'space-between',
        border: 'solid 1px #aaaaaa',
        borderRadius: 10,
        padding: theme.spacing(2),
    },
    avatar: {},
    formControl: {
        width: '100%',
    },
    addBtn: {
        margin: 20,
        width: 100,
    }
});

const trans = {
    addBtn: '新增一筆',
    plzSelect: '請選擇',
    ship: '船',
    shipName: '船名'
};


const WorkingShipCommandCenter = (props) => {
    const { classes, items, max, schedule } = props;
    const { titleWidth, data, z, changeData } = schedule;
    // 船舶選單
    const [selectedItem, setSelectedItem] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [availableItems, setAvailableItems] = useState([]);

    // 船舶工作行程
    const workingShips = data[`${z}_ships`] || [];


    useEffect(() => {
        setAvailableItems(items);
    }, [items]);
    
    useEffect(() => {
        if (schedule && items) {
            // console.log('schedule', z, titleWidth, data, schedule);
            // console.log('working ship', z, workingShips)
            if (workingShips.length > 0) {
                const updatedShips = items.filter(item => !workingShips.some(ship => ship.ship_id === item.value));
                // // 這邊要處理的原因是，第一版的API開發者，混用 id, name, 填寫的都是 ship id, 造成混亂, 這邊更新版再調整把name更新!
                // const selectedShips = items.filter(item => workingShips.some(ship => {
                //     if (ship.ship_id === item.value) {
                //         ship.ship_name = item.name;
                //         return true
                //     }
                //     return false;
                // }));
                const selectedShips = items.filter(item => workingShips.some(ship => ship.ship_id === item.value));


                setAvailableItems(updatedShips);
                setSelectedItems(selectedShips);
            }
        }
    }, [schedule]);

    const getInitialDataArray = () => {
        const shipData = data[`${z}_ships`] || [];
        return shipData;
    };

    const saveShipScheduleData = (newDataArray) => {
        const shipData = data[`${z}_ships`] || [];
        const updatedDataArray = shipData.filter((s) => s.zone_name !== z);
        updatedDataArray.push(...newDataArray);
        changeData({ label: `${z}_ships`, data: updatedDataArray });
    };

    const shipDataAry = getInitialDataArray();

    const addShipSchedule = (shipId, shipName) => {
        const newDataArray = [...shipDataAry];
        const newShipData = getInitialShipData(z, shipId, shipName);
        newDataArray.push(newShipData);

        // save to ship data array
        saveShipScheduleData(newDataArray);
    };

    const removeShipSchedule = (shipId) => {
        const newDataArray = [...shipDataAry];
        const updatedDataArray = newDataArray.map((s) => {
            if (s.ship_id === shipId) {
                if (s['id']) {
                    return { ...s, is_delete: true };
                } else {
                    return null;
                }
            }
            return s;
        });
        const filteredArray = updatedDataArray.filter((s) => s !== null);

        // save to ship data array
        saveShipScheduleData(filteredArray);
    };

    const handleAddItem = () => {
        if (selectedItem && selectedItems.length < max) {
            const { value: shipId, name: shipName } = selectedItem;
            const updatedSelectedItems = [...selectedItems, selectedItem];
            const updatedAvailableItems = availableItems.filter((availableItem) => availableItem !== selectedItem);
            setSelectedItems(updatedSelectedItems);
            setAvailableItems(updatedAvailableItems);
            // 同時要加入 ship schedule
            addShipSchedule(shipId, shipName);
            setSelectedItem('');
        }
    };

    const handleRemoveItem = (itemSchedule) => {
        const { ship_id: shipId, ship_name: shipName } = itemSchedule;
        const updatedSelectedItems = selectedItems.filter((selectedItem) => selectedItem.value !== shipId);
        const updatedAvailableItems = [...availableItems, { value: shipId, name: shipName }];
        setSelectedItems(updatedSelectedItems);
        setAvailableItems(updatedAvailableItems);
        // 同時要刪除 ship schedule
        removeShipSchedule(shipId);
    };

    const renderShipSchedule = (shipSchedule, index) => {
        // returnInputValue (不用改), checkChange(暫時用不到？), changeData, data
        const shipData = shipSchedule;

        const shipChangeData = ({ label = '', data = '' }) => {
            const newDataArray = [...shipDataAry];

            const newShipData = {
                ...shipData,
                [label]: data,
            };

            const updatedDataArray = newDataArray.map((item, i) => {
                if (i == index) {
                    return newShipData;
                }
                return item;
            });

            // save to ship data array
            saveShipScheduleData(updatedDataArray);
        };

        return (
            !shipSchedule.is_delete &&
            <ShipSchedule
                {...schedule}
                changeData={shipChangeData}
                data={shipData}
                z={z}
                shipId={shipSchedule.ship_id}
                shipName={shipSchedule.ship_name}
            />
        );

    };

    return (
        <>
            <EAA_Row>
                <EAA_Item>
                    <EAA_ItemContainer>
                        <EAA_TitleText width={titleWidth} text='工作船名' bol={true} />
                        <FormControl className={classes.formControl}>
                            <Select
                                style={{
                                    borderRadius: 14,
                                    width: '100%',
                                    height: 46,
                                    backgroundColor: 'white',
                                    textAlign: 'start',
                                    paddingLeft: 12,
                                    border: '1px solid black',
                                    color: selectedItems.length >= max ? '#B8B8B8' : 'black',
                                    cursor: 'pointer',
                                }}
                                disableUnderline
                                value={selectedItem}
                                onChange={(e) => setSelectedItem(e.target.value)}
                            >
                            <MenuItem value="" disabled>
                                {trans.plzSelect}
                            </MenuItem>
                            {availableItems.map((item) => (
                                <MenuItem key={item.value} value={item}>
                                    {item.name}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                    </EAA_ItemContainer>
                </EAA_Item>
                <EAA_Item>
                    <Button
                        className={classes.addBtn}
                        variant="outlined"
                        color="primary"
                        onClick={handleAddItem}
                        disabled={!selectedItem || selectedItems.length === max}
                    >
                        {trans.addBtn}
                    </Button>
                </EAA_Item>
            </EAA_Row>

            {workingShips.map((shipSchedule, idx) => (
                <EAA_Row key={shipSchedule.ship_id}>
                    <EAA_Item>
                        <Paper elevation={0} className={classes.card}>
                            <Grid container spacing={1} className={classes.cardContainer}>
                                {/* Working Ship header */}
                                <Grid item key={shipSchedule.ship_id} xs={12}>
                                    <Grid container spacing={1} className={classes.cardContainer}>
                                        <Grid item xs={4} style={{ textAlign: 'left' }}>
                                            <Typography variant="h6" component="span">{`${trans.shipName}: ${shipSchedule.ship_name}`}</Typography>
                                        </Grid>
                                        <Grid item xs={6}></Grid>
                                        <Grid item xs={1} style={{ textAlign: 'right' }}>
                                            <IconButton aria-label="settings" onClick={() => handleRemoveItem(shipSchedule)}>
                                                <DeleteForeverIcon style={{ color: '#f57b5d'}} />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {/* Working ShipSchedule Here */}
                                {renderShipSchedule(shipSchedule, idx)}
                            </Grid>
                        </Paper>
                    </EAA_Item>
                </EAA_Row>
            ))}
        </>
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(WorkingShipCommandCenter);
